module.exports = __webpack_public_path__ + "static/media/add.0feb476f.svg";